module.exports = __webpack_public_path__ + "img/phrases.f042051e.svg";